export const konamiCode =
	"ArrowUp,ArrowUp,ArrowDown,ArrowDown,ArrowLeft,ArrowRight,ArrowLeft,ArrowRight,b,a";
    
export const konamiCodeArray = konamiCode.split(",");
